export default "__VITE_ASSET__DfOvolA___"